export default __webpack_public_path__ + "static/media/132_vochaos_kawai_0001.a7c42182.png";